import { gql } from "@apollo/client";

export const FETCH_ASSESSMENT = gql`
  query FETCH_ASSESSMENT($id: ID!) {
    assessment(id: $id) {
      id
      dueDate
      supplier {
        id
        name
      }
      baseInfo
      category {
        id
        name
        children {
          edges {
            node {
              id
              name
              requiredSupplier
              children {
                edges {
                  node {
                    id
                    name
                    requiredSupplier
                  }
                }
              }
            }
          }
        }
      }

      questions {
        edges {
          node {
            id
            question {
              id
              category {
                id
              }
              confirmRequired
              question
              answerType
              numberListCount
              choices {
                id
                choice
                content
              }
            }
            answerText
            answerNumbers
            answerChoices
            uploadedFiles
            score
            requiredImprovement
            improvementCompleted
            improvementNote
            improvements {
              edges {
                node {
                  id
                  content
                  updatedAt
                  files
                }
              }
            }
          }
        }
      }
      status
    }
  }
`;

export const SUBMIT_IMPROVEMENT = gql`
  mutation SUBMIT_IMPROVEMENT(
    $assessmentQuestionId: ID
    $improvementId: ID
    $content: String
    $files: [String]
  ) {
    submitAssessmentImprovement(
      assessmentQuestionId: $assessmentQuestionId
      improvementId: $improvementId
      content: $content
      files: $files
    ) {
      assessmentQuestion {
        id
        improvements {
          edges {
            node {
              id
              content
              updatedAt
              files
            }
          }
        }
      }
    }
  }
`;
